// extracted by mini-css-extract-plugin
export default {"video":"index_video_i-wve"};